import { HttpClient } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";
import { UrlTool } from "_fil_local_addon/camc-cms-base/index";
import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";

class CAMCFundFiveDebt {
    constructor(fundCode) {
        this.fundCode = fundCode;
        this.reportTime = null;
        this.httpClient = new HttpClient();
        this.fund_portfolio_bond_api = FUND_API_SOURCES.FUND_PORTFOLIO_BOND_SOURCE;
    }

    async render() {
        try {
            this.reportTime = await FundReportService.getReportTime(this.fundCode);
            if (!this.reportTime) {
                this.setEmptyMessage();
                return;
            } else {
                const bondApiData = await this.getBondData();
                this.renderBondData(bondApiData);
            }
        } catch (error) {
            this.setEmptyMessage();
        }
    }

    async getBondData() {
        const bondUrl = UrlTool.addPath(this.fund_portfolio_bond_api, this.fundCode);
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
            data: {
                asat: this.reportTime,
            },
        };
        const bondData = await this.httpClient.get(bondUrl, options);
        return bondData;
    }

    renderBondData(bondApiData) {
        let bondDataArray = [];
        let bondResData = bondApiData.data;
        if (bondResData && bondResData.topSecurityList) {
            // const sortedList = bondResData.topSecurityList.sort((a, b) => parseInt(a.orderId) - parseInt(b.orderId));
            const sortedList = bondResData.topSecurityList;
            for (var i = 0; i < sortedList.length; i++) {
                bondDataArray.push(sortedList[i]);
            }
        }
        this.updateFundDate(this.reportTime);
        this.generateBondChart(bondDataArray);
    }

    setEmptyMessage(containerId) {}

    errorHandler() {}

    updateFundDate(date) {}

    generateBondChart(bondDataArray) {}
}

export default CAMCFundFiveDebt;
